<template>
  <div class="activity-score-entry">
    <activityScoreEntryTopBar @gradeChange="gradeChange" @classChange="classChange" @scoreEntryClick="scoreEntryClick"
      @studentNameSearch="studentNameSearch" :activityData="activityData" :classSelectList="classSelectList" />
    <div class="activity-score-list">
      <activityScoreEntryTable @editClick="editClick" :practiceRecordList="practiceRecordList" />
    </div>
    <!-- 分页容器 -->
    <div class="pagination-catainer">
      <pagination :pageSize="parseInt(pageInfo.pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" :total="parseInt(total)" />
    </div>
    <!-- 录入弹窗 -->
    <scoreEntryDialog :scoreEntryShow.sync="scoreEntryShow" :className="className" :classPlaceholder="classPlaceholder"
      :classProps="classProps" :classSelect="classSelect" :classSelectList="classSelectList"
      :gradeStudentList="gradeStudentList" :activityData="activityData" />
    <!-- 单个學生成績修改弹窗 -->
    <activityScoreEdit v-show="scoreEditShow" :scoreEditShow.sync="scoreEditShow" :scoreEditData="scoreEditData"
      :activityData="activityData" @editPracticeRecord="editPracticeRecord" />
  </div>
</template>

<script>
import activityScoreEntryTopBar from "./components/activity-score-entry-top-bar/activityScoreEntryTopBar.vue";
import activityScoreEntryTable from "./components/activity-score-entry-table/activityScoreEntryTable.vue";
import scoreEntryDialog from "./components/score-entry-dialog/scoreEntryDialog.vue";
import activityScoreEdit from "./components/activity-score-edit/activityScoreEdit.vue";
export default {
  components: {
    activityScoreEntryTopBar,
    activityScoreEntryTable,
    scoreEntryDialog,
    activityScoreEdit,
  },
  data() {
    return {
      activityData: null,
      scoreEntryShow: false,
      scoreEditShow: false, // 单个修改弹窗
      scoreEditData: null, // 单个修改的数据
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "",
      classData: {
        classId: "",
        className: "",
      },
      practiceRecordList: [], // 实践活动记录列表
      gradeStudentList: [], // 学生列表
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      studentName: ""
    };
  },
  provide() {
    return {
      refresh: this.getPracticeRecordList,
    };
  },
  created() {
    // 年级和班级选择列表
    this.selectSchoolAndGradeAndClassListPC();
    this.activityData = JSON.parse(this.$route.query.activityInfo);
    // console.log("实践活动数据:", this.activityData);
    this.getPracticeRecordList();
    this.selectStudentListPC();
  },
  methods: {
    studentNameSearch(e) {
      this.studentName = e;
      this.getPracticeRecordList();
    },
    gradeChange(e) {
      if (e == "") {
        this.classId = "";
      }
      this.gradeId = e;
      this.getPracticeRecordList();
    },
    classChange(e) {
      this.classId = e;
      this.getPracticeRecordList();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getPracticeRecordList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getPracticeRecordList();
    },
    // 修改实践活动记录-单学生
    editPracticeRecord(data) {
      this.put(this.$url.editPracticeRecord, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.scoreEditShow = false;
        this.getPracticeRecordList();
      });
    },
    selectStudentListPC() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.selectStudentListPC, data).then((res) => {
        // console.log("获取年级学生列表：", res);
        if (res.code !== 200) return;
        this.gradeStudentList = res.rows;
      });
    },
    // 单个修改
    editClick(item) {
      // console.log("item:", item);
      this.scoreEditShow = true;
      this.scoreEditData = item;
    },
    scoreEntryClick(e) {
      this.scoreEntryShow = e;
    },
    // 查询实践活动记录列表
    getPracticeRecordList() {
      let { schoolYear, semester, activityName } = this.activityData;
      let data = {
        // studentId: 1,
        schoolYear,
        semester,
        activityName,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        studentName: this.studentName,
        gradeId: this.gradeId,
        classId: this.classId,
      };
      this.post(this.$url.getPracticeRecordList, data).then((res) => {
        // console.log("查询实践活动记录列表:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.total = res.total;
        this.practiceRecordList = res.rows;
      });
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            this.classData.classId =
              this.classSelect[0].schoolClassList[0].classId;
            this.classData.className =
              this.classSelect[0].schoolClassList[0].className;

            // 默认选中第一个年级班级
            let firstGrade = {};
            let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            firstGrade = { gradeCode, gradeId, gradeName };
            let firstClass = {};
            let { classCode, classId, className } =
              this.classSelect[0].schoolClassList[0];
            firstClass = { classCode, classId, className };
            this.className = [firstGrade, firstClass];
            this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
          }
          console.log("this.classSelectList:", this.classSelectList);
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./activityScoreEntry.scss";
</style>